export default (params) => ({
  trigger: {
    name: 'product_plus.select_item',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      method: {
        enum: [
          'image',
          'title',
          'link',
        ],
      },
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'vendor_free_with',
          'nespresso',
          'norton',
          'free_washing',
          'free_drying',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_item',
    },
    nonInt: false,
  },
});
